<template>
  <div v-if="indexCol.valueOf() !== 3" class="daily_bonus_row" alt="">
    <div style="cursor: pointer" class="daily_bonus_col">
      <img :src="calculateIfPresentIsActiveOrNot(indexCol.valueOf() === 1 ? 1 : 4)">
      <p>{{ translationText(indexCol.valueOf() === 1 ? 1 : 4) }}</p>
    </div>
    <div class="daily_bonus_col">
      <img :src="calculateIfPresentIsActiveOrNot(indexCol.valueOf() === 1 ? 2 : 5)">
      <p>{{ translationText(indexCol.valueOf() === 1 ? 2 : 5) }}</p>
    </div>
    <div class="daily_bonus_col">
      <img :src="calculateIfPresentIsActiveOrNot(indexCol.valueOf() * 3)">
      <p>{{ translationText(indexCol.valueOf() * 3) }}</p>
    </div>
  </div>
  <div v-else class="daily_bonus_row">
    <div class="daily_bonus_col">
      <img :src="calculateIfPresentIsActiveOrNot(7)">
      <p>{{ translationText(7) }} {{ getTranslations.home_daily_bonus_day_pts }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'bonus-daily-days',
  props: {
    indexCol: Number,
  },
  methods: {
    translationText(bonusIndexInModal) {
      // eslint-disable-next-line
      return '+' + this.getTranslations['home_daily_bonus_day_' + bonusIndexInModal];
    },
    calculateIfPresentIsActiveOrNot(presentIndex) {
      if (presentIndex < this.bonusDailyModal.loginStreak) return 'static/images/daily_bonus/icon_daily_bonus_collected.png';
      else if (presentIndex === this.bonusDailyModal.loginStreak) return 'static/images/daily_bonus/icon_daily_bonus_active.png';
      return 'static/images/daily_bonus/icon_daily_bonus_locked.png';
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BonusDailyDays.vue